import React from 'react';
import styles from './index.module.scss';
import NotesSection from './notes-section';
import { EditReviewDto } from '@interfaces-clean/reviews.interface';
import ReviewSummaryCard from '@pages-clean/subject-monitoring/components/monitoring-toolkit/_shared/review-summary-card';

type Props = {
    isHalfScreen: boolean;
    studyRef: string;
    review: EditReviewDto;
};

const SMActiveReviewTabSummaryTab = ({ isHalfScreen, studyRef, review }: Props) => {
    return (
        <div className={styles.grid}>
            {review.id != null && <NotesSection studyRef={studyRef} reviewId={review.id} />}

            {review.recordId != null && (
                <ReviewSummaryCard
                    canEdit
                    isHalfScreen={isHalfScreen}
                    studyRef={studyRef}
                    reviewRecordId={review.recordId}
                    currentSummary={review.reviewSummary}
                />
            )}
        </div>
    );
};

export default SMActiveReviewTabSummaryTab;
